import { TextCodes } from '@api/types/translation/TextCodes';
import { t } from '@translations';

// COLUMNS DEFINITION
//--------------------

export const getOrderColumns = () => [
  {
    key: 'orderId',
    name: t(TextCodes.Order.Block.OrderNumber),
    sortable: true,
  },
  {
    key: 'dealerOrderId',
    name: t(TextCodes.Order.Block.DealerOrderId),
    sortable: true,
  },
  {
    key: 'customerNo',
    name: t(TextCodes.Order.Block.CustomerNo),
    sortable: true,
  },
  {
    key: 'customerName',
    name: t(TextCodes.Order.Block.CustomerName),
    sortable: true,
  },
  {
    key: 'status',
    name: t(TextCodes.Order.Block.OrderStatus),
    sortable: true,
  },
  {
    key: 'orderType',
    name: t(TextCodes.Order.Block.OrderType),
    sortable: true,
  },
  {
    key: 'erpStatus',
    name: t(TextCodes.Order.Block.OrderType),
    sortable: true,
  },
  {
    key: 'deliveryDate',
    name: t(TextCodes.Order.Block.DeliveryDate),
    sortable: true,
  },
  {
    key: 'createdOn',
    name: t(TextCodes.Order.Block.CreatedOn),
    sortable: true,
  },
  {
    key: 'createdBy',
    name: t(TextCodes.Order.Block.CreatedBy),
    sortable: true,
  },
  {
    key: 'deliveryTo',
    name: t(TextCodes.Order.Block.DeliveryTo),
    sortable: true,
  },
  {
    key: 'comment',
    name: t(TextCodes.Order.Block.Comment),
    sortable: true,
  },
  {
    key: 'traceId',
    name: t(TextCodes.Order.Block.TraceId),
    sortable: true,
  },
];
